





























import Vue from 'vue';
import { AxiosResponse } from 'axios';
import { mapState } from 'vuex';
import {
  Component, Prop, Watch, Inject,
} from 'vue-property-decorator';
import { TransactionClassificationRuleResource }
  from '@/api/transactionclassification/';
import { KFiSelector }
  from '@kasasa/fbase-components';
import { Alert, NoticeClass } from '@kasasa/fbase-components/lib';

@Component({ computed: mapState(['fiId']), components: { KFiSelector } })
export default class CopyFromFIDialog extends Vue {
    @Inject('TransactionClassificationRuleResource')
    ruleResource!:TransactionClassificationRuleResource;

    fiId!:string;

    dialog:boolean = false;

    saving:boolean = false;

    selectedFi:any = {};

    cancel() {
      this.dialog = false;
    }

    @Watch('dialog')
    onDialogToggle() {
      this.saving = false;
    }

    onOk() {
      this.saving = true;
      this.ruleResource.copy(this.fiId, this.selectedFi.fiId).then((result:AxiosResponse) => {
        this.$emit('success');
        this.dialog = false;
      })
        .catch((error:any) => {
          this.showError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    }

    showError(error:any) {
      let errorMessage:string = '';
      if (error.response && error.response.data && error.response.data.entity) {
        errorMessage = error.response.data.entity;
      } else {
        errorMessage = 'An unexpected error occurred.';
      }
      const al = new Alert(errorMessage, NoticeClass.ERROR);
      al.setTimeout(5000);
		  this.$store.dispatch('notices/add', al);
	  }
}
